export enum PaymentOrigin {
  Recurly = 'recurly',
  Shopify = 'shopify',
}
